// parse-link-header が require('url') する Node組み込みモジュールの代替。
// ブラウザの URL API で url.parse().query 相当だけを提供する。
export function parse(urlString: string): { query: string | null } {
  const { search } = new URL(urlString);
  return { query: search ? search.slice(1) : null };
}
